module.exports = __webpack_public_path__ + "static/media/publicsector2.ab0a8642.png";